<template>
  <div class="d-flex flex-column fill-height px-10">
    <FlyoutMenuHead :selectedItem="selectedItem" @close="closeFlyout" />
    <form @submit.prevent="handleUpdateOperator" autocomplete="off">
      <v-container fluid class="px-0 scrollable-container" >
        <span class="section-header">Main Info</span>
        <v-row dense class="pa-0 mb-3">
          <v-col class="mr-3">
            <!-- Operator main info fields -->
            <v-text-field
              v-model="formData.first_name"
              label="First Name"
              required
              outlined
              dense
              hide-details
              ></v-text-field>
          </v-col>
          <v-col>
             <v-text-field
              v-model="formData.last_name"
              label="Last Name"
              required
              dense
              outlined
              hide-details
              ></v-text-field>
            <!-- Add other fields as necessary -->
          </v-col>
        </v-row>
         <v-row dense class="pa-0 mb-3">
          <v-col class="mr-3">
            <!-- Operator main info fields -->
            <v-text-field
              :value="formatDateInput(formData.date_of_birth)"
              @input="val => formData.date_of_birth = val"
              label="Date of Birth"
              required
              outlined
              dense
              hide-details
              placeholder="YYYY-MM-DD"
              ></v-text-field>
          </v-col>
          <v-col>
             <v-autocomplete
               v-model="formData.gender"
               :items="gender"
               label="Gender"
               dense
               outlined
               hide-details
             ></v-autocomplete>
          </v-col>
        </v-row>
         <v-row dense class="pa-0 mb-6">
          <v-col class="mr-3">
            <!-- Operator main info fields -->
            <v-text-field
              v-model="formData.email"
              label="E-mail"
              required
              outlined
              dense
              hide-details
              ></v-text-field>
          </v-col>
          <v-col>
             <v-text-field
              v-model="formData.mobile_phone"
              label="Phone Number"
              required
              dense
              outlined
              hide-details
              ></v-text-field>
          </v-col>
        </v-row>
        <span class="section-header">Additional details</span>
        <v-row dense class="pa-0 mb-1">
          <v-col class="mr-3">
            <!-- Operator main info fields -->
            <RowSwitch
              v-model="formData.enabled"
              label="Enabled"
              class="pa-0 mb-2"
              ></RowSwitch>
          </v-col>
          <v-col>
            <v-text-field
              v-model="formData.permission_category_group_claims"
              label="Permissions"
              outlined
              dense
              hide-details
              ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense class="pa-0 mb-3">
          <v-col class="mr-3">
            <v-text-field
              v-model="formData.vision_id"
              label="Vision ID"
              dense
              outlined
              hide-details
              ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="formData.external_id"
              label="External ID"
              outlined
              dense
              hide-details
              ></v-text-field>
          </v-col>
        </v-row>
         <v-row dense class="pa-0 mb-3">
          <v-col class="mr-3">
              <v-autocomplete
                v-model="formData.tags"
                label="Tags"
                :items="tags"
                item-text="name"
                item-value="uuid"
                multiple
                return-object
                chips
                deletable-chips
                dense
                outlined
                small-chips
                class="chips-truncate-autocomplete"
                :search-input.sync="tagToAdd"
                @keydown.enter.prevent="onAddTag"
                @input="tagToAdd = null">
            <!-- ITEM LIST – bez checkboxa -->
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title class="d-flex justify-space-between">
                  <span>{{ item.name }}</span>
                  <span class="caption grey--text">
                    {{ item.total_number || 0 }} devices
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <!-- NO DATA – novi tag -->
            <template v-slot:no-data>
              <v-list-item-content class="px-4">
                <v-list-item-title class="d-flex justify-space-between">
                  <span class="caption">{{ tagToAdd }}</span>
                  <span class="caption font-weight-light">New</span>
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <!-- SELECTION – dinamicki chipovi -->
            <template v-slot:selection="{ index }">
              <span v-if="index === 0" class="d-inline-flex align-center chips-selection-wrapper">
                <v-chip
                  v-for="tag in visibleTags"
                  :key="tag.uuid"
                  small
                  close
                  class="mr-1"
                  @click:close="removeTag(tag)"
                >
                  {{ tag.name }}
                </v-chip>
                <span v-if="formData.tags.length > visibleTags.length" class="grey--text caption ml-1">
                  +{{ formData.tags.length - visibleTags.length }}
                </span>
              </span>
            </template>
          </v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="formData.locations"
              label="Locations"
              :items="getLocations"
              item-text="name"
              item-value="uuid"
              multiple
              return-object
              chips
              deletable-chips
              dense
              outlined
              small-chips
              class="chips-truncate-autocomplete"
              :search-input.sync="locationsToAdd"
              hide-details
              >
              <!-- ITEM LIST – bez checkboxa -->
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title class="d-flex justify-space-between">
                  <span>{{ item.name }}</span>
                  <span class="caption grey--text">
                    {{ item.total_number || 0 }} devices
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <!-- NO DATA – novi tag -->
            <template v-slot:no-data>
              <v-list-item-content class="px-4">
                <v-list-item-title class="d-flex justify-space-between">
                  <span class="caption">{{ locationsToAdd }}</span>
                  <span class="caption font-weight-light">New</span>
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <!-- SELECTION – dinamicki chipovi -->
            <template v-slot:selection="{ index }">
              <span v-if="index === 0" class="d-inline-flex align-center chips-selection-wrapper">
                <v-chip
                  v-for="loc in visibleLocations"
                  :key="loc.uuid"
                  small
                  close
                  class="mr-1"
                  @click:close="removeLocations(loc)"
                >
                  {{ loc.name }}
                </v-chip>
                <span v-if="formData.locations.length > visibleLocations.length" class="grey--text caption ml-1">
                  +{{ formData.locations.length - visibleLocations.length }}
                </span>
              </span>
            </template>
            </v-autocomplete>
          </v-col>
        </v-row>
         <v-row dense class="pa-0 mb-3">
          <v-col class="mr-3">
            <v-text-field
              :value="formatDateTime(formData.created_at)"
              label="Registered At"
              dense
              outlined
              hide-details
              readonly
              ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="formData.created_by_email"
              label="Registered By"
              outlined
              dense
              hide-details
              ></v-text-field>
          </v-col>
        </v-row>
          <v-row dense class="pa-0 mb-3">
          <v-col>
            <v-autocomplete
              v-model="formData.operator_groups"
              label="Operator Groups"
              :items="getGroups"
              item-text="name"
              item-value="uuid"
              chips
              deletable-chips
              return-object
              multiple
              dense
              small-chips
              class="chips-truncate-autocomplete"
              :search-input.sync="groupToAdd"
              outlined
              hide-details
              >
              <!-- ITEM LIST – bez checkboxa -->
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title class="d-flex justify-space-between">
                  <span>{{ item.name }}</span>
                  <span class="caption grey--text">
                    {{ item.total_number || 0 }} devices
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <!-- NO DATA – novi tag -->
            <template v-slot:no-data>
              <v-list-item-content class="px-4">
                <v-list-item-title class="d-flex justify-space-between">
                  <span class="caption">{{ groupToAdd }}</span>
                  <span class="caption font-weight-light">New</span>
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <!-- SELECTION – dinamicki chipovi -->
            <template v-slot:selection="{ index }">
              <span v-if="index === 0" class="d-inline-flex align-center chips-selection-wrapper">
                <v-chip
                  v-for="group in visibleOperatorGroups"
                  :key="group.uuid"
                  small
                  close
                  class="mr-1"
                  @click:close="removeOperatorGroup(group)"
                >
                  {{ group.name }}
                </v-chip>
                <span v-if="formData.operator_groups.length > visibleOperatorGroups.length" class="grey--text caption ml-1">
                  +{{ formData.operator_groups.length - visibleOperatorGroups.length }}
                </span>
              </span>
            </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <span class="section-header" ref="customFieldsSection">Custom Fields</span>
        <div class="custom-fields-grid">
          <CustomRow
            v-for="field in customFields"
            :key="field.key"
            :label="field.label"
            :fieldIndex="field.fieldIndex"
            :value="{ title: '', content: formData[field.key] || '', enabled: formData[field.enabledKey] }"
            :required="field.required"
            :unique="field.unique"
            :error-messages="fieldErrors[field.key] || []"
            @input="updateCustomFieldField(field, $event)"
          />
        </div>
      </v-container>
    </form>
    <FormFooter :type="'edit'" :currentStep="1" :totalSteps="1" @save="handleUpdateOperator" @cancel="closeFlyout" />
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex/dist/vuex.common.js';
import FlyoutMenuHead from '../FlyoutMenuHead.vue';
import RowSwitch from '../RowSwitch.vue';
import FormFooter from './FormFooter.vue';
import CustomRow from './CustomRow.vue';

export default {
  name: 'OperatorsEdit',
  components: { FlyoutMenuHead, RowSwitch, FormFooter, CustomRow },
  data() {
    return {
      selectedItem: { name: 'Edit Operator' },
      formData: {},
      selectedTag: null,
      originalData: {},
      selectedOperatorGroup: null,
      tagToAdd: '',
      groupToAdd: '',
      locationsToAdd: '',
      gender: ['male', 'female', 'other'],
      fieldErrors: {
        custom_1: [],
        custom_2: [],
        custom_3: [],
        custom_4: [],
        custom_5: [],
        custom_6: [],
        custom_7: [],
        custom_8: [],
      },
    };
  },
computed: {
  ...mapGetters('tags', ['tags']),
  ...mapGetters('locations', ['getLocations']),
  ...mapGetters('operators', ['getGroups']),
  hasChanged() {
    return JSON.stringify(this.formData) !== JSON.stringify(this.originalData);
  },
  operator() {
    const op = this.$store.getters['operators/getOperator'];
    return op;
  },
  // Dinamički limitiraj broj chipova na temelju ukupne dužine teksta
  visibleTags() {
    return this.calculateVisibleItems(this.formData.tags || []);
  },
  visibleLocations() {
    return this.calculateVisibleItems(this.formData.locations || []);
  },
  visibleOperatorGroups() {
    return this.calculateVisibleItems(this.formData.operator_groups || []);
  },
  customFields() {
    // Read alias/required/unique directly from the operator payload (formData),
    // which already embeds operator_custom_N_alias / _required / _unique / _enabled
    // per operator - no separate space-config fetch needed (same approach as OperatorView.vue).
    return Array.from({ length: 8 }, (_, i) => {
      const idx = i + 1;
      return {
        key: `custom_${idx}`,
        enabledKey: `operator_custom_${idx}_enabled`,
        fieldIndex: idx,
        required: this.formData[`operator_custom_${idx}_required`] || false,
        unique: this.formData[`operator_custom_${idx}_unique`] || false,
        label: this.formData[`operator_custom_${idx}_alias`] || `Custom ${idx}`,
      };
    });
  },

},
 mounted() {
    this.getTags("operator");
    this.setLocations();
    this.$store.dispatch('operators/fetchOperatorGroups');
    this.loadOperator();
  },
  watch: {
    '$route.params.uuid'(newVal, oldVal) {
      if (newVal !== oldVal) this.loadOperator();
    }
  },
  methods: {
    ...mapActions('operators', ['fetchOperator', 'fetchOperators', 'updateOperator']),
    ...mapActions('tags', ['getTags', 'addTag']),
    ...mapActions({'setLocations':'locations/getLocations'}),
    ...mapActions({ addAlert: 'global/addAlert' }),

    // Load operator data for current route uuid
    async loadOperator() {
      try {
        const routeUuid = this.$route.params.uuid;
        if (!this.operator || this.operator.uuid !== routeUuid) {
          await this.fetchOperator(routeUuid);
        }
        // Normalize API shape: copy operator_custom_X -> custom_X so UI and validation use consistent keys
        const op = { ...this.$store.getters['operators/getOperator'] } || {};
        for (let i = 1; i <= 8; i++) {
          const customKey = `custom_${i}`;
          const apiKey = `operator_custom_${i}`;
          if (typeof op[customKey] === 'undefined') {
            op[customKey] = op[apiKey] || '';
          }
          // ensure enabled flag exists as boolean
          const enabledKey = `operator_custom_${i}_enabled`;
          if (typeof op[enabledKey] === 'undefined') {
            op[enabledKey] = false;
          }
        }
        this.formData = op;
        this.selectedTag = this.formData.tags?.[0]?.uuid || null;
        this.selectedOperatorGroup = this.formData.operator_groups?.[0]?.uuid || null;
        this.originalData = { ...this.formData };
      } catch (err) {
        console.error('DEBUG: Fetch error:', err);
      }
    },

    formatDateInput(iso) {
      if (!iso) return '';
      const d = new Date(iso);
      if (isNaN(d)) return iso;
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    },

    formatDateTime(iso) {
      if (!iso) return '';
      const d = new Date(iso);
      if (isNaN(d)) return iso;
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const h = String(d.getHours()).padStart(2, '0');
      const min = String(d.getMinutes()).padStart(2, '0');
      return `${y}-${m}-${day} ${h}:${min}`;
    },

    // Izračunaj koliko chipova može stati u dostupni prostor (~180px za pola širine)
    calculateVisibleItems(items) {
      if (!items || items.length === 0) return [];
      const maxWidth = 160; // Maksimalna širina za chipove (u px)
      const avgCharWidth = 7; // Prosječna širina karaktera (u px)
      const chipPadding = 50; // Padding + close button za svaki chip
      
      let totalWidth = 0;
      const visible = [];
      
      for (const item of items) {
        const chipWidth = (item.name?.length || 0) * avgCharWidth + chipPadding;
        if (totalWidth + chipWidth > maxWidth && visible.length > 0) {
          break;
        }
        visible.push(item);
        totalWidth += chipWidth;
      }
      
      // Ako nema niti jedan, prikaži barem prvi
      return visible.length > 0 ? visible : items.slice(0, 1);
    },
    
    onAddTag () {
    if (!this.tagToAdd) return
    const name = this.tagToAdd
    this.tagToAdd = null
    const alreadySelected = this.formData.tags.some(
      t => t.name.toLowerCase() === name.toLowerCase()
    )
    if (alreadySelected) return

    const existing = this.tags.find(t => t.name.toLowerCase() === name.toLowerCase())
    if (existing) {
      this.formData.tags = [...this.formData.tags, existing]
      return
    }

    this.addTag(name).then(tag => {
      this.formData.tags = [...this.formData.tags, tag]
    }).catch(() => {
      this.addAlert({ type: 'error', message: `Failed to create tag ${name}.` })
    })
  },

  removeTag (tag) {
    this.formData.tags = this.formData.tags.filter(
      t => t.uuid !== tag.uuid
    )
  },
  removeOperatorGroup (operatorGroup) {
    this.formData.operator_groups = this.formData.operator_groups.filter(
      og => og.uuid !== operatorGroup.uuid
    )
  },
  removeLocations (location) {
    this.formData.locations = this.formData.locations.filter(
      l => l.uuid !== location.uuid
    )
  },
    updateCustomFieldField(field, value) {
      this.formData[field.key] = value.content;
      if (typeof value.enabled !== 'undefined') {
        this.formData[field.enabledKey] = value.enabled;
      }
      // Clear error for the field
      if (this.fieldErrors[field.key]) {
        this.$set(this.fieldErrors, field.key, []);
      }
    },

    validateCustomFields() {
      this.fieldErrors = {}; // Reset field errors
      for (let i = 1; i <= 8; i++) {
        const field = `custom_${i}`;
        const enabledKey = `operator_custom_${i}_enabled`;
        if (this.formData[enabledKey] && !this.formData[field] && this.formData[`operator_custom_${i}_required`]) {
          this.$set(this.fieldErrors, field, ['Required']);
        }
      }
      return Object.keys(this.fieldErrors).length === 0; // Return true if no errors
    },

    closeFlyout() {
      this.$router.push({ name: 'operators' });
    },
    async handleUpdateOperator() {
      // Validate custom fields before submitting
      if (!this.validateCustomFields()) {
        return; // Exit if validation fails
      }
      try {
        await this.updateOperator({ operator_uuid: this.$route.params.uuid, form: this.formData });
        await this.fetchOperators();
        this.addAlert({ message: 'Operator updated successfully', type: 'success' });
        this.closeFlyout();
      } catch (e) {
        console.error('Update operator error:', e);
        if (this.handleCustomFieldError(e)) return;
        const errorMsg = this.parseErrorMessage(e);
        this.addAlert({ message: errorMsg, type: 'error' });
      }
    },

    // Detects backend errors (409 conflict / 400 validation) tied to a specific
    // operator custom field, maps the message onto that field, and scrolls the
    // user to the Custom Fields section. Returns true if the error was handled
    // this way, false if it should fall back to generic handling.
    handleCustomFieldError(error) {
      const response = error.response;
      if (!response) return false;

      // 409 Conflict - duplicate custom field value, e.g.
      // "Operator with same 'operator_custom_1' field already exists"
      if (response.status === 409) {
        const message = response.data?.message;
        const match = message && message.match(/operator_custom_(\d+)/);
        if (match) {
          this.applyCustomFieldError(`custom_${match[1]}`, message);
          return true;
        }
      }

      // 400 validation errors - field map, e.g. { errors: { operator_custom_1: '...' } }
      if (response.status === 400) {
        const errData = response.data || {};
        const errorsObj = errData.errors || errData;
        const customKey = Object.keys(errorsObj).find((key) => /^operator_custom_\d+$/.test(key));
        if (customKey) {
          const idx = customKey.match(/\d+/)[0];
          const raw = errorsObj[customKey];
          const message = Array.isArray(raw) ? raw[0] : raw;
          this.applyCustomFieldError(`custom_${idx}`, message);
          return true;
        }
      }

      return false;
    },

    applyCustomFieldError(fieldKey, message) {
      this.$set(this.fieldErrors, fieldKey, [message]);
      this.$nextTick(() => this.scrollToCustomFields());
    },

    scrollToCustomFields() {
      const el = this.$refs.customFieldsSection;
      if (el && typeof el.scrollIntoView === 'function') {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },

    parseErrorMessage(error) {
      if (error.response?.data) {
        const data = error.response.data;
        if (data.message) return data.message;
        if (data.error) return data.error;
        if (data.detail) return data.detail;
        if (Array.isArray(data.errors) && data.errors.length > 0) {
          return data.errors.map(err => err.message || err).join(', ');
        }
        if (typeof data === 'object' && !Array.isArray(data)) {
          const messages = Object.entries(data)
            .filter(([key]) => key !== 'status' && key !== 'statusCode')
            .map(([key, value]) => `${key}: ${value}`)
            .join(', ');
          if (messages) return messages;
        }
      }
      return error.message || 'Failed to update operator';
    },
  },

};
</script>

<style scoped>
.section-header {
  font-family: Roboto;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0px;
  padding-bottom: 20px;
  display: block;
  color: #0091FF;
}
.scrollable-container {
  max-height: calc(100vh - 178px);
  overflow-y: auto;
}
.custom-fields-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}
.chips-selection-wrapper {
  max-width: 100%;
  overflow: hidden;
  flex-wrap: nowrap;
}
.chips-truncate-autocomplete ::v-deep .v-select__selections {
  flex-wrap: nowrap;
  overflow: hidden;
}
</style>